__webpack_require__.p = "https://salazabawjupiter.pl/";